module.exports = __webpack_public_path__ + "media/customize/banner-top-left-a1d53780.svg";